import React, { createContext, useContext, useState } from "react";

const INEContext = createContext();

export const INEProvider = ({ children }) => {
  // --------- Alertas (comparten cabecera) ----------
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success"); // "success" | "danger" | ...
  const [showAlertHeader, setShowAlertHeader] = useState(false);
  const openAlertHeader = () => setShowAlertHeader(true);
  const closeAlertHeader = () => setShowAlertHeader(false);

  // --------- Países (is_country = true) ----------
  const [countriesSearch, setCountriesSearch] = useState("");
  const [countriesPage, setCountriesPage] = useState(1);
  const [countriesLimit, setCountriesLimit] = useState(10);
  const [countriesTotal, setCountriesTotal] = useState(0);
  const [countriesReloadKey, setCountriesReloadKey] = useState(0);
  const bumpCountriesReload = () => setCountriesReloadKey((k) => k + 1);

  // --------- Provincias/Islas (is_country = false) ----------
  const [provincesSearch, setProvincesSearch] = useState("");
  const [provincesPage, setProvincesPage] = useState(1);
  const [provincesLimit, setProvincesLimit] = useState(10);
  const [provincesTotal, setProvincesTotal] = useState(0);
  const [provincesReloadKey, setProvincesReloadKey] = useState(0);
  const bumpProvincesReload = () => setProvincesReloadKey((k) => k + 1);

  // --------- Selección / Modales ----------
  const [selectedINEItem, setSelectedINEItem] = useState(null); // objeto completo si lo necesitas
  const [updateModalOpen, setUpdateModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const openUpdateModal = (id, item = null) => {
    setSelectedId(id);
    if (item) setSelectedINEItem(item);
    setUpdateModalOpen(true);
  };
  const closeUpdateModal = () => {
    setUpdateModalOpen(false);
    setSelectedId(null);
  };

  // --------- Sugerencias opcionales para <datalist> ----------
  const [ineValidNames, setIneValidNames] = useState([]); // ["Reino Unido", "A Coruña", ...]

  // --------- Refresh global tras crear/editar ----------
  const [refreshKey, setRefreshKey] = useState(0);
  const bumpRefresh = () => setRefreshKey((k) => k + 1);

  return (
    <INEContext.Provider
      value={{
        // Alertas
        message,
        setMessage,
        alertType,
        setAlertType,
        showAlertHeader,
        openAlertHeader,
        closeAlertHeader,

        // Países
        countriesSearch,
        setCountriesSearch,
        countriesPage,
        setCountriesPage,
        countriesLimit,
        setCountriesLimit,
        countriesTotal,
        setCountriesTotal,
        countriesReloadKey,
        bumpCountriesReload,

        // Provincias/Islas
        provincesSearch,
        setProvincesSearch,
        provincesPage,
        setProvincesPage,
        provincesLimit,
        setProvincesLimit,
        provincesTotal,
        setProvincesTotal,
        provincesReloadKey,
        bumpProvincesReload,

        // Selección / Modales
        selectedINEItem,
        setSelectedINEItem,
        updateModalOpen,
        openUpdateModal,
        closeUpdateModal,
        selectedId,

        // Sugerencias
        ineValidNames,
        setIneValidNames,

        // Refresh global
        refreshKey,
        bumpRefresh,
      }}
    >
      {children}
    </INEContext.Provider>
  );
};

export const useINE = () => useContext(INEContext);
